import {
  ArrowRightLeft,
  CalendarDays,
  CircleCheck,
  CircleX,
  Megaphone,
  MailQuestion,
  MessageCircle,
  Trophy,
  UserRoundPlus,
  type LucideIcon,
} from 'lucide-react';
import type { NotificationEventType } from '@/types/notifications';

/**
 * Só o ícone e a cor do chip. O texto da notificação NÃO vem daqui: ele é gravado
 * em `account_notifications` no disparo, já no idioma da conta, e lido de lá.
 */
export type NotificationCatalogEntry = {
  icon: LucideIcon;
  /** Solid chip background (icon is white) */
  chipClassName: string;
};

export const NOTIFICATION_CATALOG: Record<NotificationEventType, NotificationCatalogEntry> = {
  'lead.assigned': {
    icon: UserRoundPlus,
    chipClassName: 'bg-[#2563EB]',
  },
  'lead.campaign_entered': {
    icon: Megaphone,
    chipClassName: 'bg-[#0EA5E9]',
  },
  'followup.handoff': {
    icon: MailQuestion,
    chipClassName: 'bg-[#D97706]',
  },
  'calendar.ai_created': {
    icon: CalendarDays,
    chipClassName: 'bg-[#7C3AED]',
  },
  'opportunity.pipeline_changed': {
    icon: ArrowRightLeft,
    chipClassName: 'bg-[#F97316]',
  },
  'opportunity.won': {
    icon: Trophy,
    chipClassName: 'bg-[#16A34A]',
  },
  'opportunity.lost': {
    icon: CircleX,
    chipClassName: 'bg-[#DC2626]',
  },
  'conversation.opened': {
    icon: MessageCircle,
    chipClassName: 'bg-[#1E40AF]',
  },
  'conversation.closed': {
    icon: CircleCheck,
    chipClassName: 'bg-[#16A34A]',
  },
  'whatsapp.connected': {
    icon: MessageCircle,
    chipClassName: 'bg-[#25D366]',
  },
};
